import { Dialog } from "../../../../common/core-ui/Dialog.tsx";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./PublisherPrefsDialog.module.scss";

interface PublisherPrefsDialogProps {
  onRequestClose: () => void;
}

export default function PublisherPrefsDialog({
  onRequestClose,
}: PublisherPrefsDialogProps) {
  const intl = useIntl();

  return (
    <Dialog
      onRequestClose={onRequestClose}
      darkHeader
      title={intl.formatMessage({ defaultMessage: "Publisher Preferences" })}
    >
      <p className={styles.description}>
        <FormattedMessage defaultMessage="Once you mute a publisher, you will no longer receive publisher recommendations sent from them. To unmute a publisher, remove them from the Muted Publishers list." />
      </p>
      <h3 className={styles.mutedHeader}>
        <FormattedMessage defaultMessage="Muted Publishers" />
      </h3>
      <FormattedMessage defaultMessage="No muted publishers." />
    </Dialog>
  );
}
